<template>
  <div>
    <h5 class="text-left mb-5">Já Possui Cadastro ?</h5>
    <div class="login-form-container"> <!-- Alterado de v-col para div -->
      <v-form ref="formLogin">
        <v-text-field
            name="login"
            id="login"
            v-model="login.user"
            label="CPF/CNPJ"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            solo
            @keyup.enter="validateLogin()"
            :rules="rules.login_user"
        >
        </v-text-field>
        <v-text-field
            name="password"
            v-model="login.password"
            label="Senha"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            @click:append="showPassword = !showPassword"
            solo
            @keyup.enter="validateLogin()"
            :rules="rules.login_password"
        />

        <div class="recaptcha-container mb-4" v-if="isRecaptchaEnabled">
          <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaSiteKey"
              @verify="onVerifyRecaptcha"
              @expired="onExpiredRecaptcha"
          />
        </div>

        <v-alert type="error" color="#e72c1f" v-if="errorLogin !== null">
          {{ errorLogin }}
        </v-alert>
        <v-btn class="btn-white w-100" @click.prevent="validateLogin()" large style="height: 48px !important;"
               :disabled="isRecaptchaEnabled && !recaptchaVerified">
          ENTRAR
        </v-btn>
      </v-form>
    </div>
    <a @click="modal.rememberEmail = true, email = ''">Esqueci minha senha</a>
    <br>
    <a class="btn-register" href="#register-estar">Cadastre-se</a>
    <v-dialog v-model="modal.rememberEmail" width="400px">
      <v-form ref="formRememberEmail">
        <v-card :loading="loading">
          <v-card-title>
            <h3>Esqueci minha senha</h3>
            <i class="fas fa-window-close ml-auto icon-close-modal"
               @click.prevent="modal.rememberEmail = false"></i>
          </v-card-title>
          <v-card-text>
            Para recuperar sua senha, insira o seu CPF/CNPJ cadastrado no {{ appName }}.
            <v-text-field
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                class="my-3"
                :rules="rules.document"
                v-model="identification"
                label="CPF/CNPJ"
                required
            />
            <v-row justify="center" v-if="modal.rememberEmail && errorNoSendMethod">
              <v-alert width="300" type="error" color="#e72c1f">
                Selecione ao menos um metodo para o envio do codigo.
              </v-alert>
            </v-row>
            <v-row justify="space-around">
              <v-checkbox
                  class="checkbox" label="E-mail" v-model="codeSendMethod.email"
              />
              <v-checkbox
                  class="checkbox" label="SMS" v-model="codeSendMethod.sms"
              />
            </v-row>
            <v-alert type="error" color="#e72c1f" v-if="errorRemember !== null">
              {{ errorRemember }}
            </v-alert>
            <button class="btn-blue w-100" @click.prevent="validateRememberEmail()">
              Enviar
            </button>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog persistent v-model="modal.sendCode" width="350px">
      <v-form ref="formSendCode">
        <v-card class="text-center" :loading="loading">
          <v-card-title>
            <h5 style="word-break: break-word; color: #000 !important;">CODIGO ENVIADO COM SUCESSO!</h5>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-col>
                <v-row>
                  <h6>Insira o codigo recebido no campo abaixo.</h6>
                </v-row>
                <v-row>
                  <v-text-field
                      :rules="this.rules.confirmation_code"
                      label="Codigo"
                      :disabled="loading"
                      v-model="confirmationCode"
                      v-mask="'####'"
                  />
                </v-row>
                <v-row justify="center" v-if="modal.sendCode && errorConfirmationCode !== null">
                  <v-alert width="300" type="error" color="#e72c1f">
                    {{ errorConfirmationCode }}
                  </v-alert>
                </v-row>
                <v-row justify="center">
                  <v-btn
                      class="btn-cancel float-left"
                      @click.prevent="refreshPage()"
                      text
                  >Cancelar
                  </v-btn>
                  <v-btn
                      class="btn-confirm float-right"
                      @click="validateSendCode()"
                      text
                  >Confirmar
                  </v-btn>
                </v-row>
              </v-col>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog persistent v-model="modal.newPassword" width="350px">
      <v-form ref="formNewPassword">
        <v-card class="text-center" :loading="loading">
          <v-card-title><h3>Insira a nova senha a seguir:</h3></v-card-title>
          <v-card-text>
            <v-col>
              <v-row justify="center">
                <v-text-field
                    label="Nova senha"
                    type="password"
                    v-model="newPassword.password"
                    :disabled="loading"
                    :rules="rules.new_password"
                />
              </v-row>
              <v-row justify="center">
                <v-text-field
                    label="Confirme a nova senha"
                    type="password"
                    v-model="newPassword.confirmPassword"
                    :disabled="loading"
                    :rules="rules.new_password_confirmation"
                />
              </v-row>
              <v-row v-if="modal.newPassword && errorNewPassword !== null" justify="center">
                <v-alert width="300" type="error" color="#e72c1f">
                  {{ errorNewPassword }}
                </v-alert>
              </v-row>
              <v-row justify="center">
                <v-btn
                    class="btn-cancel float-left"
                    @click.prevent="refreshPage()"
                    text
                >Cancelar
                </v-btn>
                <v-btn
                    class="btn-confirm float-right"
                    @click="validateNewPassword()"
                    text
                >Confirmar
                </v-btn>
              </v-row>
            </v-col>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "login",
  components: {
    VueRecaptcha
  },
  data: function () {
    return {
      showPassword: false,
      confirmationCode: null,
      message_success: false,
      loading: false,
      modal: {
        rememberEmail: null,
        sendCode: false,
        newPassword: false,
      },
      errorLogin: null,
      errorRemember: null,
      errorNoSendMethod: null,
      errorConfirmationCode: null,
      errorNewPassword: null,
      identification: '',
      login: {
        user: null,
        password: null
      },
      recaptchaVerified: false,
      codeSendMethod: {
        sms: false,
        email: false,
      },
      newPassword: {
        password: null,
        confirmPassword: null,
      },
      rules: {
        document: [
          value => (value || '').length > 0 || 'O campo CPF/CNPJ é obrigatório',
          value => {
            return this.validCpf(value) || 'Digite um CPF/CNPJ válido'
          },
        ],
        login_user: [
          value => (value || '').length > 0 || 'O campo CPF/CNPJ é obrigatório',
        ],
        login_password: [
          value => (value || '').length > 0 || 'O campo senha é obrigatório',
        ],
        confirmation_code: [
          value => (value || '').length > 0 || 'O campo codigo é obrigatório',
          value => (value || '').length === 4 || 'O codigo deve ter 4 dígitos',
        ],
        new_password: [
          value => (value || '').length > 0 || 'O campo nova senha é obrigatório',
        ],
        new_password_confirmation: [
          value => (value || '').length > 0 || 'O campo confirme nova senha é obrigatório',
        ]
      }
    }
  },
  methods: {
    sendRememberEmail: function () {
      if (this.codeSendMethod.email === false && this.codeSendMethod.sms === false) {
        this.errorNoSendMethod = true;
        return;
      }
      this.errorNoSendMethod = false;
      this.loading = true;
      this.errorRemember = null;
      axios.post('/api/password/reset/send',
          {
            email: this.codeSendMethod.email,
            sms: this.codeSendMethod.sms,
            registration: this.identification.split('.').join('').split('-').join('').split('/').join('')
          }).then(() => {
        this.modal.sendCode = true;
        this.modal.rememberEmail = false;
      }).catch(error => {
        this.errorRemember =
            error.response.data.message
            || Object.entries(error.response.data)[0][1].message
            || Object.entries(error.response.data.error.errors)[0][1][0]
            || 'Ocorreu um erro. Tente novamente.';
      }).finally(() => {
        this.loading = false;
      });
    },
    confirmCode() {
      if (this.confirmationCode !== null && this.confirmationCode.length === 4) {
        this.loading = true;
        this.errorConfirmationCode = null;
        axios.post('/api/password/reset/check',
            {
              registration: this.identification.split('.').join('').split('-').join('').split('/').join(''),
              code: parseInt(this.confirmationCode, 10)
            }
        ).then((res) => {
          if (res.data.status === true) {
            this.modal.sendCode = false;
            this.modal.newPassword = true;
          } else {
            this.errorConfirmationCode = res.data.message;
          }
        }).catch(error => {
          this.errorConfirmationCode = error.response.data.error.message;
        }).finally(() => {
          this.loading = false;
        })
      }
    },
    sendNewPassword() {
      this.errorNewPassword = null;
      if (this.newPassword.password !== this.newPassword.confirmPassword) {
        this.errorNewPassword = 'As senhas informadas não correspondem.'
        return;
      }
      this.loading = true;
      axios.put('/api/password/reset',
          {
            registration: this.identification.split('.').join('').split('-').join('').split('/').join(''),
            code: parseInt(this.confirmationCode, 10),
            password: this.newPassword.password,
            confirm_password: this.newPassword.confirmPassword
          }
      ).then((res) => {
        localStorage.setItem('token', res.data.access_token);
        axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('token');
        axios.get('/api/user').then(res => {
          localStorage.setItem('user', JSON.stringify({
            id: res.data.id,
            driver_id: res.data.driver_id,
            identification: res.data.identification,
            name: res.data.name,
          }));
          location.reload();
        });
      }).catch(error => {
        this.errorNewPassword = error
      }).finally(() => {
        this.loading = false;
      })
    },
    validCpf: function (value) {
      value = value.split('.').join('').split('-').join('').split('/').join('');
      if (value.length === 11) {
        var Soma;
        var Resto;
        var i;
        Soma = 0;
        var strCPF = value;
        if (strCPF == "00000000000" ||
            strCPF == "11111111111" ||
            strCPF == "22222222222" ||
            strCPF == "33333333333" ||
            strCPF == "44444444444" ||
            strCPF == "55555555555" ||
            strCPF == "66666666666" ||
            strCPF == "77777777777" ||
            strCPF == "88888888888" ||
            strCPF == "99999999999")
          return false;
        for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10))) return false;
        Soma = 0;
        for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11))) return false;
        return true;
      } else if (value.length === 14) {
        var c = value;
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((c = c.replace(/[^\d]/g, "")).length != 14)
          return false;

        if (/0{14}/.test(c))
          return false;

        for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]) ;
        if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
          return false;

        for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]) ;
        if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
          return false;

        return true;
      } else {
        return false;
      }
    },
    loginDriver: function () {
      const login = {
        username: this.login.user.split('.').join('').split('-').join('').split('/').join(''),
        password: this.login.password
      };
      this.errorLogin = null;
      axios.post('/api/login', login).then(response => {
        localStorage.setItem('token', response.data.access_token);
        axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('token');
        axios.get('/api/user').then(res => {
          localStorage.setItem('user', JSON.stringify({
            id: res.data.id,
            driver_id: res.data.driver_id,
            identification: res.data.identification,
            name: res.data.name,
          }));
          this.$store.dispatch('user/setUserData', res.data);
          location.reload();
        });
      }).catch(error => {
        //design xD
        this.errorLogin = "CPF/CNPJ ou senha incorretos." || Object.entries(error.response.data)[0][1].message
      });
    },
    onVerifyRecaptcha() {
      this.recaptchaVerified = true;
    },
    onExpiredRecaptcha() {
      this.recaptchaVerified = false;
      this.$refs.recaptcha.reset();
    },
    validateLogin: function () {
      if (this.isRecaptchaEnabled && !this.recaptchaVerified) {
        this.errorLogin = "Por favor, complete o captcha antes de continuar.";
        return;
      }
      if (this.$refs.formLogin.validate() !== false) {
        this.loginDriver();
      }
    },
    validateRememberEmail() {
      if (this.$refs.formRememberEmail.validate() !== false) {
        this.sendRememberEmail();
      }
    },
    validateSendCode() {
      if (this.$refs.formSendCode.validate() !== false) {
        this.confirmCode();
      }
    },
    validateNewPassword() {
      if (this.$refs.formNewPassword.validate() !== false) {
        this.sendNewPassword();
      }
    }
  },
  computed: {
    appName: function () {
      return process.env.VUE_APP_NAME;
    },
    recaptchaSiteKey: function () {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
    },
    isRecaptchaEnabled: function () {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY !== null &&
          process.env.VUE_APP_RECAPTCHA_SITE_KEY !== undefined &&
          process.env.VUE_APP_RECAPTCHA_SITE_KEY !== '' &&
          process.env.VUE_APP_RECAPTCHA_SITE_KEY !== 'false';
    }
  },
}
</script>

<style scoped>
h5 {
  font-size: 24px !important;
  font-family: Roboto-Black !important;
  color: #ffffff !important;
}

h3 {
  font-size: 24px !important;
  font-family: Roboto-Black !important;
  color: #595959;
}

a {
  text-align: center !important;
  background: transparent;
  font-family: Roboto-Black;
  color: #ffffff !important;
  position: relative;
  z-index: 10;
}

.btn-white {
  text-transform: capitalize !important;
  background: #ffffff !important;
  color: #000 !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
  position: relative;
  z-index: 10;
}

.v-btn.v-btn--disabled.btn-white,
.v-btn.v-btn--disabled.btn-white.v-btn--has-bg,
button.btn-white.v-btn.v-btn--disabled {
  opacity: 0.7 !important;
  background-color: #f0f0f0 !important;
  color: #555555 !important;
  border: 3px solid #555555 !important;
}

.btn-white:hover {
  background: transparent !important;
  color: #ffffff !important;
  border: 3px solid #ffffff !important;
}

.btn-blue {
  text-transform: capitalize !important;
  background: #000 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
}

.btn-blue:hover {
  background: transparent !important;
  color: #000 !important;
}

.btn-register {
  color: white !important;
  padding: 10px;
  display: table;
  margin: 20px auto;
  border: 2px solid white;
  position: relative;
  z-index: 10;
}

.checkbox {
  margin: 0 0 20px 0;
}

.login-form-container {
  position: relative;
  width: 100%;
}

.recaptcha-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
  position: relative;
  z-index: 10;
  width: 100%;
  min-height: 80px;
  overflow: visible;
}

@media only screen and (max-width: 500px) {
  .recaptcha-container {
    width: 100% !important;
    margin-bottom: 20px;
    min-height: 70px;
  }

  .g-recaptcha {
    width: 100% !important;
    overflow: visible;
  }

  body {
    overflow-x: hidden;
  }
}
</style>
